import React, { Fragment } from "react"
import DOMPurify from "dompurify"

import IndexGauge from "./IndexGauge"
import WellbeingIndexChartTiny from "./WellbeingIndexChartTiny"
import { OVERVIEW_PAGE_CONTENT } from "./constants"
import { liveLifeDashboardPath } from "./LiveLife/constants"
import { getAssetPath } from "../../utils/assets"

const hasProgramBody = body => {
  if (!body) return false
  const text = body
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;|&#160;/gi, " ")
    .trim()
  return text.length > 0
}

const renderProgramBody = body => {
  const hasHtml = /<[a-z][\s\S]*>/i.test(body)
  if (hasHtml) {
    return (
      <div
        className="mb-1 program-body"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }} />
    )
  }
  return <p className="mb-1" style={{ whiteSpace: "pre-line" }}>{body}</p>
}

function OverviewContent({
  firstname,
  organisationName,
  programName,
  programHeader,
  programBody,
  integrationType,
  overviews,
  renderCalculatorActions,
  programBodyFooter = null,
  digitalContentAction = null
}) {
  return (
    <div className="dashboard-body content">
      <div className="container overview">
        <div className="pt-4">
          <h1>
            {`Hi ${firstname}`}
          </h1>
          {`Organisation: ${organisationName}`}
          <hr />
        </div>
        <h4 className="my-3 py-3">
          {`Currently Enrolled Program: ${programName}`}
        </h4>
        {!!integrationType && (
          <div className="card mb-5">
            <div className="card-body">
              <div className="program-resource">
                <img src={getAssetPath("Digital-Content")} />
                <div className="program-resource-content d-md-flex ml-4 ml-md-0">
                  <div className="mx-md-4">
                    {programHeader
                      ? (
                        <h4>{programHeader}</h4>
                      )
                      : (
                        <h4>
                          Access
                          {" "}
                          <span>{programName}</span>
                          {" "}
                          Digital Content
                        </h4>
                      )}
                    {hasProgramBody(programBody)
                      ? renderProgramBody(programBody)
                      : (
                        <p className="mb-1">
                          On-demand access to the resource-rich digital content to further embed change. Includes all Educational Webinars and Connection Zone classes.
                        </p>
                      )}
                    {programBodyFooter}
                  </div>
                  {digitalContentAction}
                </div>
              </div>
            </div>
          </div>
        )}

        {overviews.map(overview => {
          if (overview.calculator_type === null) return null
          const isV2 = overview.calculator_type === "live_life" && String(overview.version) === "2"
          const content = isV2
            ? OVERVIEW_PAGE_CONTENT.live_life_v2
            : OVERVIEW_PAGE_CONTENT[overview.calculator_type]
          if (!content) return null
          const logoSrc = getAssetPath(content.logoAssetName)
          const dashboardHref = overview.calculator_type === "live_life"
            ? liveLifeDashboardPath(overview.version)
            : content.dashboardHref
          return (
            <Fragment key={overview.calculator_type}>
              <div className="calc-item">
                <div className="card">
                  <div className="card-body">
                    <div className="calc-intro d-md-flex align-items-start">
                      <img className="mb-2" src={logoSrc} />
                      <div className="ml-1">
                        <h4 className="my-1">{content.header}</h4>
                        <p>{content.description}</p>
                      </div>
                    </div>
                    <div className="calc-item-footer justify-content-space-between">
                      <div className="calc-summary-container">
                        <div className="calc-summary">
                          <IndexGauge
                            category={overview?.latest_wellbeing?.category}
                            color={overview?.latest_wellbeing?.color}
                            index={overview?.latest_wellbeing?.index} />
                        </div>
                        {!!(overview?.calculator_results?.length > 1) && (
                          <div className="calc-summary recharts">
                            <WellbeingIndexChartTiny results={overview?.calculator_results} />
                          </div>
                        )}
                      </div>
                      <div className="links">
                        {renderCalculatorActions({
                          overview, content, dashboardHref, isV2
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                {overview?.latest_wellbeing?.completed_at && <small className="d-block mt-2 text-muted">{`Last completed on ${overview?.latest_wellbeing?.completed_at}`}</small>}
              </div>
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default OverviewContent
